import { NavigationMenu } from "radix-ui";
import { FC } from "react";
import useAuthRoute from "~/hook/useAuthRoute";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_URL } from "~/utils/constant";
import { wantsDesktop } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "../mobile-menu/type";

const BannerItem: FC<PropsType> = ({ data, isImagePreloaded }) => {
  const { handleNavigate } = useAuthRoute();

  return (
    <div className="w-[350px] h-auto">
      <div className={cn("grid grid-cols-1 gap-4")}>
        {data?.length > 0
          ? data?.map((item) => {
              const isVisible = wantsDesktop(item.show_menu);
              return (
                isVisible && (
                  <NavigationMenu.Link asChild key={item.id}>
                    <div
                      className="group flex flex-col items-center gap-y-2 cursor-pointer transition-all duration-200 hover:scale-[1.02] shadow-lg shadow-primaryColor/30 rounded-xl overflow-hidden"
                      onClick={() => handleNavigate(item.navigate_to)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleNavigate(item.navigate_to);
                        }
                      }}
                    >
                      <ImageWithSkeleton
                        url={{
                          small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                          medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                          large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                          hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                          original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                        }}
                        alt={item.name ?? "Icon"}
                        className="w-[350px] h-auto object-contain rounded-xl shadow-md group-hover:shadow-xl transition-shadow duration-300"
                        loadImageLazy={false}
                        isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                        useSkeletonLoader={true}
                      />
                      {/* <img src={item.icon} loading="eager" alt={item.name ?? "Banner Item"} className="rounded-lg w-[350px] h-auto object-contain" /> */}
                    </div>
                  </NavigationMenu.Link>
                )
              );
            })
          : null}
      </div>
    </div>
  );
};

export default BannerItem;
